export default "__VITE_ASSET__B_U9GDI___"